import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { GridValue } from "src/app/components/default/form/form.interface";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixValidator } from "../../PrefixValidator";
import { PrefixComponent } from "../../prefix.component";
import { TemplateGridComponent } from "../../templates/template-grid/template-grid.component";

@Component({
  selector: "app-prefix-gr3",
  imports: [TemplateGridComponent],
  templateUrl: "./prefix-gr3.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-gr3.component.less",
})
export class PrefixGr3Component extends PrefixComponent<GridValue[]> implements OnInit {
  @Input()
  public date: boolean;

  @Input()
  public text: boolean;

  public constructor() {
    super();
    this.date = false;
    this.text = false;
    this.characters = ALLOWED_CHARACTERS["gr3"];
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.control.addValidators(PrefixValidator.optionsAll());
    this.control.updateValueAndValidity();
  }
}
